import { render } from "./AuditLogsPage.vue?vue&type=template&id=d5c41bf8&scoped=true"
import script from "./AuditLogsPage.vue?vue&type=script&lang=js"
export * from "./AuditLogsPage.vue?vue&type=script&lang=js"

import "./AuditLogsPage.vue?vue&type=style&index=0&id=d5c41bf8&scoped=true&lang=css"

import exportComponent from "/usr/app/saas-stack/customer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c41bf8"]])

export default __exports__